import styled from "styled-components";
import { spacingIncrement } from "../../../../utils/common";

export const Container = styled.div<{ paddingLeft?: number }>`
  padding-left: ${({ paddingLeft }) => spacingIncrement(paddingLeft || 0)};
  display: flex;
  cursor: pointer;
`;
